import { createLink, Outlet } from '@tanstack/react-router';
import styled from 'styled-components';

import { IconButton, Popover } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { space } from '@creditornot/alchemy-react/tokens';
import { CountrySelector } from 'common/components/cookbook/CountrySelector/CountrySelector';
import { NavigationBar } from 'common/components/cookbook/NavigationBar/NavigationBar';
import { Stack } from 'common/components/cookbook/Stack';
import { ViewMeta } from 'common/components/cookbook/ViewMeta';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSelectedCountryCodes } from 'common/hooks/useSelectedCountryCodes';
import { media } from 'common/media';

import FinanceTabs from './components/Tabs';

const RouterIconButton = createLink(IconButton);

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex-grow: 1;
  padding-block: ${space.regularXxxlarge};
  gap: ${space.regularXxxlarge};
`;

const StyledFinanceTabs = styled(FinanceTabs)`
  padding-inline: ${space.regularXxxlarge};
  flex-shrink: 0;

  @media ${media.maxMd} {
    scrollbar-width: none;
  }
`;

const OutletWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex-grow: 1;
  padding-inline: ${space.regularXxxlarge};
`;

export const ListViewWrapper = () => {
  const selectedCountryCodes = useSelectedCountryCodes();
  const format = useFormatMessage();
  const settingsDisabled = selectedCountryCodes.length !== 1;
  const pageTitle = format('finance.finance_flows');

  return (
    <ViewMeta title={pageTitle}>
      <NavigationBar
        disableBottomContentPadding
        className="invoices-navigation-bar"
        title={pageTitle}
        titleContent={<CountrySelector />}
        rightContent={
          <Stack gap="regularXlarge" direction="row">
            <div>
              <Popover
                placement="start"
                trigger={
                  <RouterIconButton
                    to="/finance/invoices/settings"
                    disabled={settingsDisabled}
                    aria-label={format('common.settings')}
                    icon={icons.gear}
                    size="small"
                    variant="secondaryNeutral"
                  />
                }
                openOnHover={settingsDisabled}
                openOnClick={false}
              >
                <Popover.Content>
                  {format('invoices.select_one_country_to_view_settings')}
                </Popover.Content>
              </Popover>
            </div>
          </Stack>
        }
      />
      <ContentWrapper>
        <StyledFinanceTabs />
        <OutletWrapper>
          <Outlet />
        </OutletWrapper>
      </ContentWrapper>
    </ViewMeta>
  );
};
